/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ParcelPartFilterType = 'FULL_OWNERSHIP' | 'OUR_COOWNERSHIP' | 'PARTIAL_COOWNERSHIP';

export const ParcelPartFilterType = {
    FULL_OWNERSHIP: 'FULL_OWNERSHIP' as ParcelPartFilterType,
    OUR_COOWNERSHIP: 'OUR_COOWNERSHIP' as ParcelPartFilterType,
    PARTIAL_COOWNERSHIP: 'PARTIAL_COOWNERSHIP' as ParcelPartFilterType
};

